import { create } from "zustand";
import { persist } from "zustand/middleware";
import { User } from "@/models/users/User";

type UserStore = {
  me: User | null;
  setMe: (user: User | null) => void;
  hasCalledLogin: boolean;
  setHasCalledLogin: (hasCalledLogin: boolean) => void;
  clear: () => void;
};

const useUserStore = create(
  persist<UserStore>(
    (set) => ({
      me: null,
      hasCalledLogin: false,
      setMe: (user) => set({ me: user }),
      setHasCalledLogin: (hasCalledLogin) => set({ hasCalledLogin }),
      clear: () => set({ me: null, hasCalledLogin: false }),
    }),
    {
      name: "user-me-store",
    }
  )
);

export default useUserStore;
